import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import { styled } from "styled-components";
import { useUrlParams } from "../hooks/useUrlParams";

const SpinnerPage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
`;

export const CampaignReturn = () => {
  const { queryParams, routeParams } = useUrlParams();
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = queryParams.session_id;

    if (!sessionId) {
      // No session ID, redirect back to campaign
      navigate(`/campaign/${routeParams.id}`);
      return;
    }

    // Redirect to campaign page with success flag
    // The webhook will have already processed the payment
    navigate(`/campaign/${routeParams.id}?paymentSuccess=true`);
  }, [queryParams.session_id, routeParams.id, navigate]);

  return (
    <SpinnerPage>
      <Spinner size={"xl"} />
    </SpinnerPage>
  );
};
